// extracted by mini-css-extract-plugin
export default {"header-slogan-list":"header-slogan-list_header-slogan-list__fxcLa"};